import React, { useState, Fragment, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import PageTitle from "../../layouts/PageTitle";
import { useSelector, useDispatch } from "react-redux";
import Toastr from "../../components/common/Toastr";
import swal from "sweetalert";
import { Button } from "react-bootstrap";
import { changepasswordActions } from "../../../_store";

const AdminPasscodeSettings = () => {
  const dispatch = useDispatch();
  const currentUser = useSelector((x) => x.auth.user);

  const [isRevealPwd, setIsRevealPwd] = useState(false);

  const [passcode, setPasscode] = useState("");

  useEffect(() => {
    dispatch(changepasswordActions.GetAdminPasscode(currentUser.Id)).then(
      (response) => {
        if (response?.type === "changepassword/GetAdminPasscode/fulfilled") {
          setPasscode(response?.payload?.AdminPasscode);
        }
      }
    );
  }, [dispatch]);

  const handleSubmit = () => {
    if (!passcode) {
      return Toastr("Please enter Admin Passcode.", "warning");
    }

    swal({
      text: "Are you sure you want to update the Admin Passcode?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((ok) => {
      if (ok) {
        dispatch(
          changepasswordActions.savePasscode({
            UserID: currentUser.Id,
            Passcode: passcode,
          })
        ).then((response) => {
          if (response?.type === "changepassword/savePasscode/fulfilled") {
            if (response?.payload === 1) {
              Toastr("Admin Passcode updated successfully!", "success");
            } else if (response?.payload === 2) {
              Toastr(
                "Admin Passcode already exists. Please try a different one.",
                "warning"
              );
            } else {
              Toastr(
                "Failed to update Admin Passcode. Please try again.",
                "warning"
              );
            }
          }
        });
      }
    });
  };

  //   const reset = () => {
  //     setPasscode("");
  //   };

  return (
    <Fragment>
      <PageTitle activeMenu="Admin Passcode" motherMenu="Settings" />
      <ToastContainer />

      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-xs-12 col-md-6 col-lg-4">
                  {/* Admin Passcode */}
                  <div className="mb-3">
                    <label className="text-black font-w700">
                      Admin Passcode <span className="text-danger">*</span>
                    </label>
                    <div className="input-group mb-3">
                      <input
                        type={isRevealPwd ? "text" : "password"}
                        name="Passcode"
                        className="form-control"
                        placeholder="Enter Admin Passcode"
                        value={passcode}
                        maxLength={10}
                        onChange={(e) => setPasscode(e.target.value)}
                      />
                      <span className="input-group-text togglePassword">
                        <i
                          title={isRevealPwd ? "Hide" : "Show"}
                          className={
                            isRevealPwd
                              ? "fa fa-eye-slash PasswordHideShow"
                              : "fa fa-eye PasswordHideShow"
                          }
                          onClick={() => setIsRevealPwd(!isRevealPwd)}
                        />
                      </span>
                    </div>
                  </div>

                  {/* Buttons */}
                  {/* <Button variant="danger light" onClick={reset}>
                    Reset
                  </Button> */}

                  <Button className="btn btn-primary" onClick={handleSubmit}>
                    Update Passcode
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AdminPasscodeSettings;
